/* src/app/features/modalidade_garantia/modal-percentuais-garantidos/modal-percentuais-garantidos.component.scss */
.alert {
  margin-top: 1em !important;
}
/*# sourceMappingURL=modal-percentuais-garantidos.component.css.map */
